import { Input } from "./ui/input";
import { Field, NativeSelect } from "./Common";
import { GENDERS } from "../lib/helpers";

export const PROFILE_BLANK = { dob: "", gender: "", address: "", city: "", postcode: "", country: "" };
export const PROFILE_KEYS = Object.keys(PROFILE_BLANK);
export const missingProfile = (v, omit = []) => PROFILE_KEYS.filter((k) => !omit.includes(k) && !(v?.[k] || "").trim());

export function ProfileFields({ value, onChange, t, testPrefix = "client", required = false, omit = [] }) {
  const star = required ? " *" : "";
  const show = (k) => !omit.includes(k);
  const inp = (k, type = "text") => (
    <Input data-testid={`${testPrefix}-${k}-input`} type={type} value={value[k] || ""} onChange={(e) => onChange({ ...value, [k]: e.target.value })} />
  );
  return (
    <>
      <Field label={t("dob") + star}>{inp("dob", "date")}</Field>
      <Field label={t("gender") + star}>
        <NativeSelect testId={`${testPrefix}-gender-select`} value={value.gender || ""} onChange={(v) => onChange({ ...value, gender: v })}
          options={[{ value: "", label: "—" }, ...GENDERS.map((g) => ({ value: g, label: t(`g_${g}`) }))]} />
      </Field>
      {show("address") && <Field label={t("street_address") + star} className="sm:col-span-2">{inp("address")}</Field>}
      <Field label={t("city") + star}>{inp("city")}</Field>
      {show("postcode") && <Field label={t("postcode") + star}>{inp("postcode")}</Field>}
      <Field label={t("country") + star}>{inp("country")}</Field>
    </>
  );
}

export function formatAddress(c) {
  return [c.address, c.city, c.postcode, c.country].filter(Boolean).join(", ");
}
